export const RECENT_SEARCHES_KEY = "chronos.recentSearches";
export const RECENT_SEARCHES_MAX = 6;

/** The last keywords searched on this browser, newest first. */
export const readRecentSearches = (): string[] => {
	try {
		const raw = window.localStorage.getItem(RECENT_SEARCHES_KEY);
		const list: unknown = raw ? JSON.parse(raw) : [];
		return Array.isArray(list)
			? list.filter((s): s is string => typeof s === "string" && !!s)
			: [];
	} catch {
		return [];
	}
};

/**
 * Remembers a keyword at the front of the list (deduplicated, trimmed,
 * capped at `RECENT_SEARCHES_MAX`) and returns the new list.
 */
export const pushRecentSearch = (keyword: string): string[] => {
	const value = keyword.trim();
	const current = readRecentSearches();
	if (!value) return current;

	const next = [
		value,
		...current.filter((s) => s.toLowerCase() !== value.toLowerCase()),
	].slice(0, RECENT_SEARCHES_MAX);
	write(next);
	return next;
};

export const clearRecentSearches = () => write([]);

const write = (list: string[]) => {
	try {
		window.localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(list));
	} catch {
		// Private mode, quota: the list is a convenience, nothing depends on it.
	}
};
